export default function JobApplyPreferencesPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Preferencias de empleo</h1>

      <div className="card bg-base-100 shadow">
        <div className="card-body space-y-4">
          <div className="form-control">
            <label className="label">
              <span className="label-text font-medium">Cargos objetivo</span>
            </label>
            <input
              type="text"
              placeholder="Ej: Desarrollador Frontend, Diseñador UX"
              className="input input-bordered"
            />
            <label className="label">
              <span className="label-text-alt">
                Lista separada por comas de los cargos que buscas
              </span>
            </label>
          </div>

          <div className="form-control">
            <label className="label">
              <span className="label-text font-medium">Ubicaciones</span>
            </label>
            <input
              type="text"
              placeholder="Ej: Bogota, Remoto, Medellin"
              className="input input-bordered"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="form-control">
              <label className="label">
                <span className="label-text font-medium">Tipo de empleo</span>
              </label>
              <div className="flex flex-wrap gap-2">
                {[
                  'Tiempo completo',
                  'Contrato',
                  'Remoto',
                  'Medio tiempo',
                ].map((type) => (
                  <label key={type} className="label cursor-pointer gap-2">
                    <input
                      type="checkbox"
                      className="checkbox checkbox-primary checkbox-sm"
                    />
                    <span className="label-text">{type}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text font-medium">
                  Limite diario de postulaciones
                </span>
              </label>
              <input
                type="number"
                defaultValue={15}
                min={1}
                max={30}
                className="input input-bordered w-24"
              />
            </div>
          </div>

          <div className="form-control">
            <label className="label">
              <span className="label-text font-medium">
                Empresas excluidas
              </span>
            </label>
            <input
              type="text"
              placeholder="Empresas a las que no quieres postularte"
              className="input input-bordered"
            />
          </div>

          <div className="card-actions justify-end mt-4">
            <button className="btn btn-primary">Guardar preferencias</button>
          </div>
        </div>
      </div>
    </div>
  );
}
